

export default class ServerResponseModel {

    statusCode = (rApi) =>{
        if(rApi === 200){
            return true
        }else{
            return false
        }
    }

}



//